<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>
#app {
  font-family: "微软雅黑", "Microsoft YaHei";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #111111;
}
</style>
